/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {

  if (!($('#reviews').length > 0)) { return; }

  var bindShowMore = function bindShowMore() {
    $('[data-more-reviews]').not('.click-bound').click(function(e) {
      $('[data-overflow-reviews]').show();
      return $('[data-more-reviews]').addClass('disabled');
    });
    return $('[data-more-reviews]').addClass('click-bound');
  };

  bindShowMore();

  if (!($('[data-review-modal]').length > 0)) { return; }

  var bindCreateReview = function bindCreateReview() {
    $('[data-create-review]').not('.click-bound').click(function(e) {
      $('[data-create-review]').hide();
      $('[data-review-modal]').show();

      $("form#new_review")[0].reset();
      $('input[name="review[rating]"]:checked').prop('checked', false);
      $('input[name="review[rating]"]').trigger('change');
      $('[name="review[period_used]"]').trigger('change');

      var review_form = $('#new_review');
      $('#new_review').find('input[name=_method]').remove();
      review_form[0].action = $('[data-create-path]').data('create-path');
      return $('input#review_base').prop('value', 'Submit review');
    });

    $('[data-create-review]').addClass('click-bound');


    $('[data-review-modal-close]').not('.click-bound').click(function(e) {
      $('[data-review-modal]').hide();
      return $('[data-create-review]').show();
    });

    $('[data-review-modal-close]').addClass('click-bound');


    $('form#new_review input[name="review[rating]"]').not('.bound').change(function() {
      if ($(this).is(':checked')) {
        var kiwi_label = $(this).closest('label');
        kiwi_label.nextAll('.radio').find('input[name="review[rating]"]').removeClass('checked');
        kiwi_label.nextAll('.radio').find('input[name="review[rating]"]').parent().removeClass('checked');
        $(this).addClass('checked');

        $(this).parent().addClass('checked');
        kiwi_label.prevAll('.radio').find('input[name="review[rating]"]').addClass('checked');
        return kiwi_label.prevAll('.radio').find('input[name="review[rating]"]').parent().addClass('checked');
      } else {
        $(this).removeClass('checked');
        $(this).parent().removeClass('checked');
        return $(this).find('.checked').removeClass('checked');
      }
    });

    $('form#new_review input[name="review[rating]"]:checked').trigger('change');

    return $('form#new_review input[name="review[rating]"]').addClass('bound');
  };


  var bindEditReview = function bindEditReview(elm) {
    return $(elm).find('[data-update-path]').click(function(e) {
      $('[data-review-modal]').show();
      $('[name="review[title]"]').val(
        $(elm).closest('[data-review-title]').data('review-title')
      );
      $('[name="review[positive_points]"]').val(
        $(elm).closest('[data-review-positive]').data('review-positive')
      );
      $('[name="review[negative_points]"]').val(
        $(elm).closest('[data-review-negative]').data('review-negative')
      );
      var rating = $(elm).closest('[data-review-rating]').data('review-rating');
      $('input#review_rating_' + rating).prop('checked', true);
      $('input[name="review[rating]"]:checked').trigger('change');

      var recommended = $(elm).closest('[data-review-recommended]').data('review-recommended');
      $('input[value=' + recommended + ']').prop('checked', true);

      var period = $(elm).closest('[data-review-period]').data('review-period');
      $('[name="review[period_used]"]').val(period);
      $('[name="review[period_used]"]').trigger('change');

      var review_form = $('#new_review');
      var crud_method = document.createElement('input');
      crud_method.type="hidden";
      crud_method.name="_method";
      crud_method.value="put";

      review_form[0].action = $('[data-update-path]').data('update-path');
      review_form.append(crud_method);

      return $('input#review_base').prop('value', 'Update review');
    });
  };

  var bindPersonalControls = function bindPersonalControls() {
    if (!($('[data-current-member]').length > 0)) { return; }
    if (!($('[data-author]').length > 0)) { return; }
    var current = $('[data-current-member]').data('current-member');
    return $('[data-author]').not('.control-bound').each(function(i, elm) {
      $(elm).addClass('control-bound');
      if ($(elm).data('author') === current) {
        $(elm).find('[data-review-controls]').show();

        return bindEditReview(elm);
      }
    });
  };

  bindCreateReview();
  bindPersonalControls();

  return $('html').on('consumer:reviews:refreshed', function() {
    bindShowMore();
    bindCreateReview();
    return bindPersonalControls();
  });
});
